import { React } from "react";
import { useState, useEffect, useRef } from "react";
import Wrapper from "../../components/UI/Wrapper";
import axios from "axios";
import "../../components/LeadPaymentDetails/LeadPaymentDetails.css";
import "../../components/LeadRefundDetails/LeadRefundDetails.css";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import JSZip from "jszip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

const LeadRefundDetails = ({
  Relocation_Id,
  Customer_Name,
  No_of_Pet,
  Pet_Name,
  Pet_Type,
  Ops_Coordinator,
  module,
}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const location = useLocation();
  const [refundReceiptResponse, setrefundReceiptResponse] = useState([]);
  const [decryptionError, setDecryptionError] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef_old = useRef(null);
  const fileInputRef_new = useRef(null);
  const [latestPaymentReceiptId, setLatestPaymentReceiptId] = useState("");
  const [openIndex, setOpenIndex] = useState(null);
  const [remarksList, setRemarksList] = useState([]);

  // Fetch rows data from the API
  useEffect(() => {
    getDocument(Relocation_Id);
  }, []);

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",
    request_Type: "",
    revised_amount: "",
    refund_amount: "",
    old_estimate_docPath: "",
    old_estimate_docName: "",
    new_estimate_docPath: "",
    new_estimate_docName: "",
    remark: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      setDecryptionError(true);

      return null;
    }
  }

  async function getDocument(Relocation_ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.get(
          `${baseAPI}userget/GetRefundReceipts?relocation_id=${Relocation_ID}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.RefundReceipts.length > 0
        ) {
          setrefundReceiptResponse(response.data.data.RefundReceipts);
          setRemarksList(response.data.data.RefundRemarks);
          const latestReceipt = Math.max(
            ...response.data.data.map((item) => item.refundCancellationID)
          );
          setLatestPaymentReceiptId(latestReceipt);
          return latestReceipt;
        } else {
          return null;
        }
      } catch (error) {
        console.error("Error fetching user detail:", error);
        return null;
      }
    }
    return null;
  }

  function getUpdatedImage(file, name) {
    if (file) {
      setFirstItem({
        ...firstItem,
        [name]: file, // Store the file object directly
      });
    }
  }

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      // Perform ZIP content validation here
      // This might include extracting the files, verifying file types, etc.
      // Client-side libraries like JSZip can help inspect ZIP files
      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };

    reader.readAsArrayBuffer(file);
  }

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "old_estimate_docName" || name === "new_estimate_docName") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (
          file.type === "application/zip" ||
          file.type === "application/x-zip-compressed"
        ) {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setFirstItem({
        ...firstItem,
        [name]: value,
      });
    }
  }

  const uploadDocument = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!firstItem.old_estimate_docName && !firstItem.new_estimate_docName) {
      alert("Please select both the documents before uploading.");
      return;
    }
    if (!firstItem.request_Type) {
      alert("Please select Request Type");
      return;
    }
    const formData = new FormData();
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    // Append form fields and the file to FormData
    formData.append("relocation_id", Relocation_ID);
    formData.append("request_Type", firstItem.request_Type);
    formData.append("revised_amount", firstItem.revised_amount);
    formData.append("refund_amount", firstItem.refund_amount);
    formData.append("remark", firstItem.remark);

    // Ensure the file itself is being sent
    formData.append("old_estimate_docName", firstItem.old_estimate_docName); // This will now be the file object
    formData.append("new_estimate_docName", firstItem.new_estimate_docName);

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/UploadRefundCancellation`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data", // Ensure you're sending form data
          },
        }
      );

      // Reset after success
      setFirstItem({
        request_Type: "",
        revised_amount: "",
        refund_amount: "",
        old_estimate_docPath: "",
        old_estimate_docName: "",
        new_estimate_docPath: "",
        new_estimate_docName: "",
        remark: "",
      });

      if (fileInputRef_old.current) {
        fileInputRef_old.current.value = "";
      }

      if (fileInputRef_new.current) {
        fileInputRef_new.current.value = "";
      }

      getDocument(Relocation_ID);

      toast.success("Receipt has been uploaded", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error("Error posting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "";

    const date = new Date(isoDate);
    if (isNaN(date)) return "";

    const day = date.toLocaleString("en-GB", { day: "2-digit" });
    const month = date.toLocaleString("en-GB", { month: "short" });
    const year = date.getFullYear();
    const time = date.toLocaleString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month} ${year} | ${time}`;
  };

  return (
    <>
      <Wrapper className="LeadDetails">
        <div className="viewLeadDetails-form">
          <table
            style={{
              width: "100%",
              color: "#6A6A6A",
              borderRadius: "5px",
            }}
          >
            <tr className="viewLeadDetailsHeading">
              <th
                colSpan={4}
                style={{
                  background: "#5B489D",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <span style={{ fontSize: "18px" }}>
                  {" "}
                  Refund and Cancellation{" "}
                </span>
              </th>
            </tr>

            <tr className="viewLeadDetailsHeading">
              <th>
                <span>Customer Name</span>
              </th>
              <td>
                <span>{Customer_Name}</span>
              </td>
              <th>
                <span>Number of Pets</span>
              </th>
              <td>
                <span>{No_of_Pet}</span>
              </td>
            </tr>

            <tr className="viewLeadDetailsHeading">
              <th>
                <span>Pet Name | Type</span>
              </th>
              <td>
                <span>
                  {Pet_Name} | {Pet_Type}
                </span>
              </td>
              <th>
                <span>Request Type</span>
              </th>
              <td>
                <select
                  className="form-control"
                  name="request_Type"
                  value={firstItem.request_Type}
                  onChange={handleChange1}
                >
                  <option>Please Select*</option>
                  <option value="1">Partial Refund</option>
                  <option value="2">Full Refund</option>
                </select>
              </td>
            </tr>

            <tr className="viewLeadDetailsHeading">
              <th>
                <span>Revised Amount</span>
              </th>
              <td>
                <input
                  className="form-control"
                  type="number"
                  name="revised_amount"
                  value={firstItem.revised_amount}
                  onChange={handleChange}
                />
              </td>
              <th>
                <span>Refund Amount</span>
              </th>
              <td>
                <input
                  className="form-control"
                  type="number"
                  name="refund_amount"
                  value={firstItem.refund_amount}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr className="viewLeadDetailsHeading">
              <th>
                <span>Upload Old Estimate</span>
              </th>
              <td>
                <input
                  id="old_estimate_docName"
                  type="file"
                  name="old_estimate_docName"
                  onChange={handleChangeDoc}
                  ref={fileInputRef_old}
                  required
                  className="form-control"
                  style={{ width: "-webkit-fill-available" }}
                />
              </td>
              <th>
                <span>Upload New Estimate</span>
              </th>
              <td>
                <input
                  id="new_estimate_docName"
                  type="file"
                  name="new_estimate_docName"
                  onChange={handleChangeDoc}
                  ref={fileInputRef_new}
                  required
                  className="form-control"
                  style={{ width: "-webkit-fill-available" }}
                />
              </td>
            </tr>
            <tr className="viewLeadDetailsHeading">
              <th>
                <span>Remark (if any)</span>
              </th>
              <td colSpan={3}>
                <div
                  className="row"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "70px",
                  }}
                >
                  <div className="col-10">
                    <input
                      // className="form-control"
                      type="text"
                      name="remark"
                      value={firstItem.remark}
                      onChange={handleChange}
                      style={{ width: "100%", height: "32px" }}
                    />
                  </div>
                  <div className="col-2">
                    <button
                      style={{
                        backgroundColor: "#5B489D",
                        color: "white",
                        width: "93%",
                      }}
                      className="btn btn-success inputDoc3"
                      onClick={uploadDocument}
                    >
                      Submit Request
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <div>
          {refundReceiptResponse !== null
            ? refundReceiptResponse.map((item, index) => (
                <>
                  <div className="viewLeadDetails-form">
                    <table
                      style={{
                        width: "100%",
                        color: "#6A6A6A",
                        borderRadius: "5px",
                      }}
                    >
                      <tr className="viewLeadDetailsHeading">
                        <th
                          colSpan={4}
                          style={{
                            background: "#5B489D",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          <span style={{ fontSize: "18px" }}>
                            {" "}
                            Request Details
                          </span>
                        </th>
                      </tr>
                    </table>
                  </div>

                  <div
                    style={{
                      border: "1px solid #DEE2E6",
                      borderRadius: "10px",
                      marginBottom: "-55px",
                    }}
                  >
                    <table className="paymentHistory">
                      <tr style={{ backgroundColor: "#F0EBFF" }}>
                        <th>Requested Time and Date</th>
                        <th>Request Type</th>
                        <th>Operations Coordinator</th>
                        <th>Revised Amount</th>
                        <th>Refund Amount</th>
                        <th>Status</th>
                        <th></th>
                      </tr>

                      <tr>
                        <td>{formatDate(item.created_date)}</td>
                        <td>
                          {item.request_Type === 1
                            ? "Partial Refund"
                            : "Full Refund"}
                        </td>
                        <td>{Ops_Coordinator}</td>
                        <td>₹ {item.revised_amount}</td>
                        <td>₹ {item.refund_amount}</td>
                        <td
                          style={{
                            color: item.is_status === 0 ? "#FFA500" : "#20BF44",
                          }}
                        >
                          {item.is_status === 0 ? "Requested" : "Verified"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            style={{
                              position: "relative",
                              top: "-33px",
                              maxWidth: "54px",
                              boxShadow: "0 1px 8px rgba(0, 0, 0, 0.25)",
                              border: "none",
                            }}
                            onClick={() =>
                              setOpenIndex(openIndex === index ? null : index)
                            }
                          >
                            {openIndex === index ? (
                              <FontAwesomeIcon icon={faAngleDown} />
                            ) : (
                              <FontAwesomeIcon icon={faAngleUp} />
                            )}
                          </button>
                        </td>
                      </tr>
                    </table>

                    {openIndex === index && (
                      <>
                        <hr />
                        <div className="viewLeadDetails-form">
                          <table
                            style={{
                              width: "100%",
                              color: "#6A6A6A",
                              borderRadius: "5px",
                            }}
                          >
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Customer Name</span>
                              </th>
                              <td>
                                <span>{Customer_Name}</span>
                              </td>
                              <th>
                                <span>Number of Pets</span>
                              </th>
                              <td>
                                <span>{No_of_Pet}</span>
                              </td>
                            </tr>

                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Pet Name | Type</span>
                              </th>
                              <td>
                                <span>
                                  {Pet_Name} | {Pet_Type}
                                </span>
                              </td>
                              <th>
                                <span>Sales Coordinator Approval</span>
                              </th>
                              <td>
                                <span></span>
                              </td>
                            </tr>

                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Upload Old Estimate</span>
                              </th>
                              <td>
                                {item.old_estimate_docName && (
                                  <span>
                                    <a
                                      style={{
                                        color: "#0096EB",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                      }}
                                      target="_blank"
                                      href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.old_estimate_docName}`}
                                      rel="noopener noreferrer"
                                    >
                                      Estimate
                                    </a>
                                  </span>
                                )}
                              </td>
                              <th>
                                <span>Upload New Estimate</span>
                              </th>
                              <td>
                                {item.new_estimate_docName && (
                                  <span>
                                    <a
                                      style={{
                                        color: "#0096EB",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                      }}
                                      target="_blank"
                                      href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.new_estimate_docName}`}
                                      rel="noopener noreferrer"
                                    >
                                      Estimate
                                    </a>
                                  </span>
                                )}
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Sales Manager Approval</span>
                              </th>
                              <td></td>
                              <th>
                                <span>Accounts Approval</span>
                              </th>
                              <td
                                style={{
                                  color:
                                    item.is_status === 0
                                      ? "#FFA500"
                                      : "#20BF44",
                                }}
                              >
                                <span>
                                  {" "}
                                  {item.is_status === 0
                                    ? "Requested"
                                    : "Verified"}{" "}
                                </span>
                              </td>
                            </tr>
                          </table>
                        </div>

                        <h3
                          style={{
                            marginTop: "1rem",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {" "}
                          Remarks Timeline
                        </h3>
                        <div
                          style={{
                            width: "100%",
                            maxHeight: "300px",
                            overflowY: "scroll",
                            alignItems: "center",
                          }}
                        >
                          <table
                            className="customerDetailsTable"
                            style={{ width: "99%", marginLeft: "5px" }}
                          >
                            {remarksList
                              .filter(
                                (remark) =>
                                  remark.refundCancellationID ===
                                  item.refundCancellationID
                              )
                              .map((remark, index) => (
                                <div
                                  className="wrapper"
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    margin: "1rem",
                                    padding: "1rem",
                                    borderBottom: "1px solid #ddd",
                                  }}
                                  key={index}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <h3 className="card-title">
                                      <b>Remark</b>
                                    </h3>
                                    <p className="card-text">
                                      <b>{formatDate(remark.created_date)}</b>
                                    </p>
                                  </div>
                                  <div
                                    className="row"
                                    style={{
                                      paddingTop: "11px",
                                      border: "none",
                                    }}
                                  >
                                    <div className="col-12">
                                      <div
                                        className="card"
                                        style={{
                                          width: "100%",
                                          background: "none",
                                        }}
                                      >
                                        <div className="card-body">
                                          <p
                                            className="card-text"
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {remark.Name} - {remark.remark}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </table>
                        </div>
                      </>
                    )}

                    <br />
                  </div>
                  <br />
                  <br />
                </>
              ))
            : null}
        </div>
      </Wrapper>
      <br />
    </>
  );
};

export default LeadRefundDetails;
